import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.333 15.666V5.583a2.75 2.75 0 0 1 2.75-2.75.916.916 0 0 0 0-1.833A4.59 4.59 0 0 0 17.5 5.583v10.339l-2.506.835a2.8 2.8 0 0 0-.143-.916l-1.424-4.675A2.756 2.756 0 0 0 9.973 9.38L3.83 11.332a2.76 2.76 0 0 0-1.795 3.417l1.498 4.925c.097.275.239.532.418.762l-2.324.774a.917.917 0 1 0 .58 1.742l13.55-4.515a3.68 3.68 0 0 0 3.55 4.561c4.82-.124 4.841-7.177.025-7.332M5.274 19.1 3.79 14.218a.92.92 0 0 1 .602-1.139l6.142-1.952a.916.916 0 0 1 1.147.585l1.419 4.68.01.028a.92.92 0 0 1-.466 1.12l-6.313 2.107a.92.92 0 0 1-1.057-.546m14.035 2.064a1.833 1.833 0 1 1 0-3.666 1.833 1.833 0 0 1 0 3.666m-9.096-7.332a.917.917 0 0 1-.596 1.15l-2.259.72a.917.917 0 1 1-.555-1.748l2.26-.718a.917.917 0 0 1 1.15.596"
    }, null, -1)
  ]))]))
}
export default { render: render }